module.exports = __webpack_public_path__ + "img/رمان-صورة.794f1b05.png";